import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Footer from './components/Footer';

function NotFound() {
  return (
    <div className="App legal-page">
      <header className="legal-header">
        <Container className="d-flex align-items-center justify-content-between py-3">
          <Link to="/" className="brand-text d-flex align-items-center legal-brand-link">
            <img src="/mintHubLogo.png" alt="MintHub - Professional websites for local businesses" className="brand-logo me-2" />
            <span><span className="brand-mint">Mint</span><span className="brand-hub">Hub</span></span>
          </Link>
          <Link to="/" className="legal-back-link">&larr; Back to Home</Link>
        </Container>
      </header>

      <Container className="legal-content py-5 text-center">
        <h1 className="section-title mb-3">404 - Page Not Found</h1>
        <p className="text-muted mb-4">Sorry, the page you're looking for doesn't exist or may have been moved.</p>
        <Button as={Link} to="/" size="lg" className="btn-custom px-5">
          Back to Home
        </Button>
      </Container>

      <Footer />
    </div>
  );
}

export default NotFound;
